import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const gFullImageCss = ".g__full-image{box-sizing:border-box}.g__full-image--figure{margin:0}.g__full-image--image{width:100%;object-fit:cover;display:block;max-height:455px}@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none){.g__full-image--image{max-height:100%}}.g__full-image--ignore-max-height .g__full-image--image{max-height:none}";
const GFullImageStyle0 = gFullImageCss;

const GFullImage = /*@__PURE__*/ proxyCustomElement(class GFullImage extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.imageSmallUrl = undefined;
        this.imageMediumUrl = undefined;
        this.imageLargeUrl = undefined;
        this.imageAltText = undefined;
        this.ignoreMaxHeight = undefined;
        this.dataTestId = undefined;
    }
    render() {
        var _a, _b;
        const baseClass = 'g__full-image';
        const componentClasses = {
            [baseClass]: true,
            [`${baseClass}--ignore-max-height`]: Boolean(this.ignoreMaxHeight),
        };
        return (h(Host, { key: '3e9daeb56de03f6b9b1a897741b69e975d6571e5', class: componentClasses, "data-testid": ((_a = this.dataTestId) === null || _a === void 0 ? void 0 : _a.host) || baseClass }, h("figure", { key: 'f7381a9fcadeb83169d28f555d60271a0dcdd7fa', class: "g__full-image--figure" }, h("picture", { key: 'a7217db3c793baac9bb2593222d99be0ed7694ab', class: "g__full-image--picture" }, h("source", { key: '34839af56cc87d822a8638cddcdfbee1ac9d8402', media: "(max-width: 640px)", srcSet: this.imageSmallUrl }), h("source", { key: '95c908f04e2507707c00f22ac1cf4e250783df2d', media: "(max-width: 990px)", srcSet: this.imageMediumUrl }), h("source", { key: '7ef9cb89291ed029655721331f198464296ad55d', media: "(min-width: 990px)", srcSet: this.imageLargeUrl }), h("img", { key: '40b8ba26ca94965b707818f1a6a1646486183446', class: "g__full-image--image", src: this.imageLargeUrl, alt: this.imageAltText, "data-testid": (_b = this.dataTestId) === null || _b === void 0 ? void 0 : _b.image })))));
    }
    static get style() { return GFullImageStyle0; }
}, [0, "g-full-image", {
        "imageSmallUrl": [1, "image-small-url"],
        "imageMediumUrl": [1, "image-medium-url"],
        "imageLargeUrl": [1, "image-large-url"],
        "imageAltText": [1, "image-alt-text"],
        "ignoreMaxHeight": [4, "ignore-max-height"],
        "dataTestId": [16]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["g-full-image"];
    components.forEach(tagName => { switch (tagName) {
        case "g-full-image":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, GFullImage);
            }
            break;
    } });
}

export { GFullImage as G, defineCustomElement as d };

//# sourceMappingURL=g-full-image2.js.map